import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import Transition from '@ember/routing/-private/transition';
import CollectionsIndexController from 'cio/pods/collections/index/controller';
import DS from 'ember-data';

export default class CollectionsIndexRoute extends Route {
  @service store!: DS.Store;

  queryParams = {
    sort: {
      replace: true,
    },
    asc: {
      replace: true,
    },
  };

  beforeModel() {
    return this.store.unloadAll('collection');
  }

  model() {
    return this.store.findAll('collection');
  }

  resetController(controller: CollectionsIndexController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.setDefaults();
    }
  }
}
